module.exports = __webpack_public_path__ + "961b878a8da3126404e8b6dd6c223efe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/e/e29.jpg
// module id = 561
// module chunks = 0